import * as Styled from "./TechniquesFiltersForm.styled"


export function TechniquesFiltersFormSkeleton() {

    return <Styled.Skeleton />
}